const tr = {
  nav: {
    how: "Nasıl çalışır?",
    sectors: "Sektörler",
    pricing: "Fiyatlandırma",
    blog: "Blog",
    faq: "SSS",
    login: "Giriş Yap",
    start: "Ücretsiz Başla",
  },
  hero: {
    badge: "AEO / GEO · Yapay Zekâ Marka Radar Radarı",
    title: "Müşteriler artık yapay zekâya soruyor. Peki yapay zekâ sizi öneriyor mu?",
    subtitle:
      "ChatGPT, Gemini ve Perplexity üzerinde marka görünürlüğünüzü ölçün, rakiplerinizle karşılaştırın ve pazar payınızı yapay zekâ çağında yönetin.",
    primary: "Ücretsiz Skorunu Öğren",
    secondary: "Örnek Raporu Gör",
  },
  common: {
    contact: "İletişime Geç",
    start: "Ücretsiz Başla",
    readMore: "Devamını Oku",
    soon: "yakında",
  },
};

export default tr;
